import React, { FC } from 'react';

interface Props {
	className?: string;
}

export const HorizontalAspectRatioIcon: FC<Props> = ({ className }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="65" height="31" xmlSpace="preserve" stroke="none">
			<path d="M65 31H0V0h65v31zM1 30h63V1H1v29z" />
			<path d="M30.5 19.2h-5.7v-1.4l1.9-1.9c.5-.6.9-1 1.1-1.2.2-.2.3-.4.4-.5.1-.2.1-.3.1-.5s-.1-.4-.2-.5-.4-.2-.6-.2c-.2 0-.5.1-.7.2-.3.1-.5.3-.9.6l-1.2-1.4c.4-.4.7-.6 1-.8.3-.2.6-.3.9-.4.3-.1.7-.1 1.1-.1.5 0 1 .1 1.4.3.4.2.7.4.9.8.2.3.3.7.3 1.1 0 .3 0 .6-.1.9-.1.3-.2.5-.4.8-.2.3-.4.5-.6.8-.3.3-.8.8-1.7 1.6v.1h3v1.7zM31.4 14.1c0-.3.1-.6.3-.8s.5-.3.8-.3c.4 0 .6.1.8.3s.3.4.3.8c0 .3-.1.6-.3.8s-.5.3-.8.3c-.4 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8zm0 4.2c0-.3.1-.6.3-.8.2-.2.5-.3.9-.3s.6.1.8.3.3.4.3.8c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.4 0-.6-.1-.8-.3-.3-.2-.4-.4-.4-.8zM39.1 19.2H37v-5.6c-.1.2-.3.3-.5.5l-.9.7-1.1-1.4 2.7-2.2h1.9v8z" />
		</svg>
	);
};
